var chunkMapping = {
	"1678": [
		14378,
		57893,
		55876,
		37056,
		26749,
		50197,
		56863,
		55695,
		60748,
		56443,
		18411,
		64434,
		57428
	],
	"6689": [
		26897
	],
	"9315": [
		88092
	]
};
var idToExternalAndNameMapping = {
	"14378": [
		"default",
		"./auth",
		332
	],
	"18411": [
		"default",
		"./hooks",
		18599
	],
	"26749": [
		"default",
		"./provider",
		332
	],
	"26897": [
		"default",
		"./AdServeBanner",
		18599
	],
	"37056": [
		"default",
		"./logout",
		332
	],
	"50197": [
		"default",
		"./query",
		332
	],
	"55695": [
		"default",
		"./QuickInsights",
		18599
	],
	"55876": [
		"default",
		"./dialog",
		332
	],
	"56443": [
		"default",
		"./adobe",
		332
	],
	"56863": [
		"default",
		"./InsightsMessagingQueue",
		18599
	],
	"57428": [
		"default",
		"./routing",
		332
	],
	"57893": [
		"default",
		"./config",
		332
	],
	"60748": [
		"default",
		"./feature-flag",
		332
	],
	"64434": [
		"default",
		"./widget",
		18599
	],
	"88092": [
		"default",
		"./state",
		332
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_modules__[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_modules__[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}